export default __webpack_public_path__ + "f362ade904dd78763afe0be71ceb327d.png";